import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withFirebase, isEmpty, isLoaded } from 'react-redux-firebase';
import { withRouter } from 'react-router-dom';
import { compose, withProps } from 'recompose';
import PropTypes from 'prop-types';
import {
  openCompanySignupModal,
  openInfluencerSignupModal
} from '../../store/actions/signupModalActions';
import { openSignupModal } from '../../store/actions/signupModalActions';
import MetaTags from 'react-meta-tags';
import 'bootstrap/dist/css/bootstrap.css';
import './Home.css';
import Fade from 'react-reveal/Fade';


const mapDispatchToProps = dispatch => {
  return {
    openCompanySignupModal: () => dispatch(openCompanySignupModal()),
    openInfluencerSignupModal: () => dispatch(openInfluencerSignupModal()),
    openSignupModal: () => dispatch(openSignupModal())
  };
};

const enhance = compose(
    // Map redux state to props
    connect(
        ({ firebase: { auth, profile } }) => ({
          auth,
          profile
        }),
        mapDispatchToProps
    ),
    // Add props.router (used in handlers)
    withRouter,

    // Add props.firebase (used in handlers)
    withFirebase,

    // Add custom props
    withProps(({ auth, profile }) => ({
      authExists: isLoaded(auth) && !isEmpty(auth),
      auth
    }))
);

class LandingA extends Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      show: false
    };
  }


  handleClose() {
    this.setState({ show: false });
  }

  handleShow() {
    this.setState({ show: true });
  }

  handleOpenCompanySignupModal = () => {
    this.props.openCompanySignupModal();
  };

  handleOpenInfluencerSignupModal = () => {
    this.props.openInfluencerSignupModal();
  };

  handleOpenLoginModal = e => {
    e.preventDefault();
    this.props.openSignupModal();
  };

  componentDidMount() {
  }

  render() {
    const additonalButtonStyle = {
      textAlign: 'center',
      margin: '0 auto'
    }
    const highlightTextStyle ={
      color: "#1fc26e"
    }
    const brandSectionStyle = {
      color: 'transparent',
      backgroundSize: "cover",
      // minHeight: '100%',
    }
    return (
      <React.Fragment>
        <div className="for-companies-container">
          <MetaTags>
            <title>Hype Up Your Reach for Free with HypePilot</title>
            <meta
                name="description"
                content="Connect with and source the hottest influencers on leading platforms like YouTube. Our platform allows direct messaging with influencers and provides the info that counts via analytics which provide details like follower counts and more."
            />
            <meta
                name="keywords"
                content="Influencer Marketing, Influencer Platform, Influencer Marketplace,YouTube Influencers, Instagram Influencers, Twitch Influencers,YouTube,Instagram,Twitch,Influencer,Influencers,Marketplace,Platform"
            />
          </MetaTags>
          <div className="nav-bar-holder">
            <nav className="navbar navbar-expand-sm navbar-light" />
          </div>
            <Fade top>
          <div className="text-header-container">
            <div className="container">
              <div className="header-holder">
                <h1 className="page-text-heading-brand" style={{width: '80%'}}>Grow Your Audience</h1>
                {/*<h3>Build Your Connections</h3>*/}
              </div>
              <p className="padded-top-paragraph">
                As a business, brand, or product manufacturer
                trying to thrive in the gaming scene, you need new,
                fresh, and professional gamer-centric digital marketing to
                keep moving forward. One of the most rewarding and exciting
                ways to grow your gaming audience is to connect with gaming influencers!
              </p>
              <br/>
            </div>
          </div>
        </Fade>

        <Fade bottom>
          <div className="brands-section" style={{
            ...brandSectionStyle,
            minHeight:"50vh",
            backgroundPosition: 'center',
            backgroundImage: "url('images/landing/pexels-rodnae-productions-7915224.jpg')"
          }}/>
          </Fade>
          <Fade top>
          <div className="text-header-container container">
          <div className="header-holder">
            <h1 className="page-text-heading-brand" style={{width: '80%'}}>Why Influencers?</h1>
          </div>
          <p className="padded-top-paragraph">
            There’s a reason why gaming influencers are so incredibly powerful as a marketing tool.
            People want to connect with people, which means that having an actual face and personality
            representing your brand to the masses is a way to personalize and humanize your audience’s
            experience. They act as ambassadors for your brand to show their usually sprawling
            audiences that you’re a name that can be trusted.
          </p>
            <br/>
          </div>
          </Fade>
          <Fade bottom>
          <div className="brands-section" style={{
            ...brandSectionStyle,
            minHeight:"50vh",
            backgroundPosition: 'center',
            backgroundImage: "url('images/landing/pexels-cottonbro-4009594.jpg')"
          }}/>
          </Fade>
          <Fade top>
            <div className="text-header-container container">
              <div className="header-holder">
                <h1 className="page-text-heading-brand" style={{width: '80%'}}>Step Into the Open Gaming Marketplace with HypePilot</h1>
              </div>
              <p className="padded-top-paragraph">
                <b style={highlightTextStyle}>Connecting gamers to companies</b> just
                like yours is what we do best.
                We know that you’ve poured countless
                hours and resources into creating
                awesome gaming products, which is
                why we want to help you keep growing.
              </p>
              <br/>
            </div>
          </Fade>
          <Fade bottom>
            <div className="brands-section" style={{
              ...brandSectionStyle,
              minHeight:"50vh",
              backgroundPosition: 'center',
              backgroundImage: "url('images/landing/pexels-rodnae-productions-7915492.jpg')"
            }}/>
          </Fade>
          <Fade top>
            <div className="text-header-container container">
              <div className="header-holder">
                <h1 className="page-text-heading-brand" style={{width: '80%'}}>Make The Right Connections</h1>
              </div>
              <p className="padded-top-paragraph">
                Now that you know you need to make connections
                to be able to branch out, it’s time to start
                making the right connections. Each professional e-sports
                influencer and gaming personality has their own, unique
                audience, niche, and focus. You need to find and connect
                with someone who knows how to not only market your products
                and brand to their audience, but do it in a way that’s
                professional, reliable and, most importantly, rewarding.
              </p>
              <br/>
            </div>
          </Fade>
          <Fade bottom>
            <div className="brands-section" style={{
              ...brandSectionStyle,
              minHeight:"50vh",
              backgroundPosition: 'center',
              backgroundImage: "url('images/landing/pexels-rodnae-productions-7915277.jpg')"
            }}/>
          </Fade>
          <Fade top>
          <div className="text-header-container container">
            <div className="header-holder">
              <h1 className="page-text-heading-brand" style={{width: '80%'}}>Scope Out the Situation</h1>
            </div>
            <p className="padded-top-paragraph">
              Our <b style={highlightTextStyle}>open gaming marketplace</b> is built on a platform that
              allows you to get to know the gaming influencers that you might
              soon be working with. We’ll give you complete insight into the
              kind of content that they create and share, as well as how their
              audience interacts with them. See how well their content performs
              and start connecting with gaming influencers who have the reach you’re looking for.
            </p>
            <br/>

          </div>
          </Fade>

          <Fade bottom>
          <div className="brands-section" style={{
            ...brandSectionStyle,
            minHeight:"50vh",
            backgroundPosition: 'center',
            backgroundImage: "url('images/landing/pexels-rodnae-productions-7915357.jpg')"
          }}/>
          </Fade>
          <Fade top>
            <div className="text-header-container container">
              <div className="header-holder">
                <h1 className="page-text-heading-brand" style={{width: '80%'}}>Why Your Business Needs HypePilot</h1>
              </div>
              <p className="padded-top-paragraph">
                When it comes to playing in the digital space,
                no one compares to HypePilot. It’s not just our
                incredible skill and close attention to detail
                that sets us apart from our competitors; it’s the
                fact that we allow our influencers and gaming
                professionals to keep complete control and ownership
                over the content that they create. Why does that matter
                to you? Because our platform attracts professional and
                committed gaming influencers who genuinely care about their content.
              </p>
              <br/>
            </div>
          </Fade>

          <Fade bottom>
            <div className="brands-section" style={{
              ...brandSectionStyle,
              minHeight:"50vh",
              backgroundPosition: 'center',
              backgroundImage: "url('images/landing/pexels-rodnae-productions-7915440.jpg')"
            }}/>
          </Fade>
          <Fade top>
          <div className="text-header-container container">
            <div className="header-holder">
              <h1 className="page-text-heading-brand" style={{width: '80%'}}>Start Creating Killer Campaigns</h1>
            </div>
            <p className="padded-top-paragraph">
              Working with HypePilot gives businesses more power, more freedom,
              and more affordable ways to gain the benefits of influencer marketing
              without the need for a multi-million-dollar marketing spend.
              Our model is simple. We use an Upwork-style fee system that
              involves charging 15% for deals under $100, and 10% for deals over $100.
              Better yet, we don’t charge businesses registration
              fees to become a part of our open gaming marketplace.
              We keep our communications with content creators and
              businesses as transparent as possible so that we can help you
              diversify your reach without any hidden costs or policies. Our platform:
            </p>
            <ul>
              <li>Is API integrated</li>
              <li>Has AI-Fueled Verification Systems</li>
              <li>Doesn’t Require Sign Up Fees for Companies</li>
            </ul>

            <a
                onClick={this.handleOpenLoginModal}
                className="btn py-3 px-5 orange-button banner-content">Sign Up</a>
          </div>
          </Fade>
          <div className="brands-section" style={{
            ...brandSectionStyle,
            minHeight:"40vh",
            backgroundPosition: 'center',
            color: "white",
            backgroundImage: "url('images/landing/pexels-lucie-liz-3165335.jpg')"
          }}>
          <div className="text-header-container container" >
            <div className="header-holder">
              <h1 className="page-text-heading-brand" style={{width: '80%'}}>Contact Us</h1>
            </div>
            <p className="padded-top-paragraph">
              If you’re ready to grow your gaming
              audience and connect with the gaming influencers
              who work as hard as you do, reach out to the HypePilot team now!
            </p>

            <br/>
              <a onClick={() => {
                window.open("https://calendly.com/hypepilot/15min", "_blank")
              }}
                 className="btn py-3 px-5 orange-button banner-content"
                 style={additonalButtonStyle}>
                Schedule Demo
              </a>
            <br/>
            <br/>

          </div>
          </div>

          <div className="nav-bar-holder">
            <nav className="navbar navbar-expand-sm navbar-light" />
          </div>
        </div>
      </React.Fragment>
    );
  }
}

LandingA.propTypes = {
  authExists: PropTypes.bool,
  router: PropTypes.object
};

export default enhance(LandingA);



// WEBPACK FOOTER //
// ./src/components/home/LandingA.js